module.exports = __webpack_public_path__ + "static/media/ic-lock.71fef8fc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/ic-lock.svg
// module id = 638
// module chunks = 14